import { defineMessages } from 'react-intl';

export default defineMessages({
    whatTitle: {
        id: 'portal.fnol.wizard.step.wc.What',
        defaultMessage: 'What'
    },
    wcReportOfInjuryLabel: {
        id: 'portal.fnol.wizard.step.wc.Have you completed an',
        defaultMessage: "First complete an {employersReport} (select Resource: Claims Kit for your state) and select {Yes} to continue with expedited experience."
    },
    wcWhereTitle: {
        id: 'portal.fnol.wizard.step.wc.Where',
        defaultMessage: 'Where'
    },
    wcInjuryTitle: {
        id: 'portal.fnol.wizard.step.wc.Injury',
        defaultMessage: 'Injury'
    },
    fnolSaveDraftErrorTitle: {
        id: 'portal.fnol.config.FlowConfig.Unable to save draft claim information',
        defaultMessage: 'Unable to save draft claim information'
    },
    fnolSaveDraftErrorMessage: {
        id: 'portal.fnol.config.FlowConfig.An error occurred while attempting to save the claim submission.',
        defaultMessage: 'We are currently unable to access your data. Please contact us at 1-800-231-1363 so that we can assist.'
    },
    wcInjuryDetails: {
        id: 'portal.fnol.wc.views.injury.Injury Details',
        defaultMessage: 'Injury Details'
    },
    wcInjuryType: {
        id: 'portal.fnol.wc.views.injury.Injury Type',
        defaultMessage: 'Injury Type'
    },
    wcSelectInjuryType: {
        id: 'portal.fnol.wc.views.injury.Select injury type',
        defaultMessage: '-- Select injury type --'
    },
    wcInjuryDescription: {
        id: 'portal.fnol.wc.views.injury.Injury Description',
        defaultMessage: 'Injury Description'
    },
    wcInjuryResultDeath: {
        id: 'portal.fnol.wc.views.injury.Injury/illness result in death?',
        defaultMessage: 'Injury/illness result in death?'
    },
    wcInjuryWorkTimeLost: {
        id: 'portal.fnol.wc.views.injury.Lost time from work?',
        defaultMessage: 'Lost time from work?'
    },
    wcInjuryMedicalTreatment: {
        id: 'portal.fnol.wc.views.injury.Medical Treatment',
        defaultMessage: 'Medical Treatment'
    },
    wcInjuryMedicalAttentionRequired: {
        id: 'portal.fnol.wc.views.injury.Medical attention required?',
        defaultMessage: 'Medical attention required?'
    },
    wcInjuryExaminationDate: {
        id: 'portal.fnol.wc.views.injury.Examination Date',
        defaultMessage: 'Examination Date'
    },
    wcInjuryDoctorFirstName: {
        id: 'portal.fnol.wc.views.injury.Doctor\'s_First Name',
        defaultMessage: 'Doctor\'s First Name'
    },
    wcInjuryDoctorLastName: {
        id: 'portal.fnol.wc.views.injury.Doctor\'s_Last Name',
        defaultMessage: 'Doctor\'s Last Name'
    },
    wcInjuryDoctorFirstNameKanji: {
        id: 'portal.fnol.wc.views.injury.Doctor\'s_First Name Kanji',
        defaultMessage: 'Doctor\'s First Name Kanji'
    },
    wcInjuryDoctorLastNameKanji: {
        id: 'portal.fnol.wc.views.injury.Doctor\'s_Last Name Kanji',
        defaultMessage: 'Doctor\'s Last Name Kanji'
    },
    wcInjuryBodyInjuries: {
        id: 'portal.fnol.wc.views.injury.Body Injuries',
        defaultMessage: 'Body Injuries'
    },
    wcInjuryAdditionalBodyInjury: {
        id: 'portal.fnol.wc.views.injury.Additional body injury?',
        defaultMessage: 'Additional body injury?'
    },
    wcInjuryAddAnotherBodyInjury: {
        id: 'portal.fnol.wc.views.injury.Add Another Body Injury',
        defaultMessage: 'Add Another Body Injury'
    },
    wcInjuryBodyArea: {
        id: 'portal.fnol.views.injury.Body Part',
        defaultMessage: 'Body Part #{bodyAreaCount}'
    },
    wcInjuryAreaOfBody: {
        id: 'portal.fnol.wc.views.injury.Area of Body',
        defaultMessage: 'Area of Body'
    },
    wcInjurySelectAreaOfBody: {
        id: 'portal.fnol.wc.views.injury.Select Area of Body',
        defaultMessage: '-- Select Area of Body --'
    },
    wcInjuryBodyPart: {
        id: 'portal.fnol.wc.views.injury.Body Part',
        defaultMessage: 'Body Part'
    },
    wcInjurySelectBodyPart: {
        id: 'portal.fnol.wc.views.injury.Select Body Part',
        defaultMessage: '-- Select Body Part --'
    },
    wcInjuryBodyPartDescription: {
        id: 'portal.fnol.wc.views.injury.Body Part Description',
        defaultMessage: 'Body Part Description'
    },
    wcInjurySelectBodyPartDescription: {
        id: 'portal.fnol.wc.views.injury.Select Body Part Description',
        defaultMessage: '-- Select Body Part Description --'
    },
    wcInjurySide: {
        id: 'portal.fnol.wc.views.injury.Side',
        defaultMessage: 'Side'
    },
    wcInjurySelectSide: {
        id: 'portal.fnol.wc.views.injury.Select Side',
        defaultMessage: '-- Select Side --'
    },
    wcInjuryRemoveBodyInjury: {
        id: 'portal.fnol.wc.views.injury.Remove Body Injury',
        defaultMessage: 'Remove Affected Body Part'
    },
    wcInjuryModalRemoveBodyInjury: {
        id: 'portal.fnol.wc.views.injury.Are you sure you want to remove Body Injury #: {bodyPartDetail}?',
        defaultMessage: 'Are you sure you want to remove Body Part # {bodyPartDetail}?'
    },
    wcInjuryRemoveButton: {
        id: 'portal.fnol.wc.views.injury.Remove',
        defaultMessage: 'Remove'
    },
    wcInjuryOccurredInCourseOfEmployment: {
        id: 'portal.fnol.wc.views.injury.Did the injury occur in course of Employment?',
        defaultMessage: 'Did the injury occur in course of Employment?'
    },
    wcCreateDraftClaim: {
        id: 'portal.fnol.wc.config.FlowConfig.Creating draft claim...',
        defaultMessage: 'Creating draft claim...'
    },
    wcCreateDraftErrorTitle: {
        id: 'portal.fnol.wc.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    wcCreateDraftErrorMessage: {
        id: 'portal.fnol.wc.config.FlowConfig.An error occurred attempting to create a claim.',
        defaultMessage: 'An error occurred attempting to create a claim.'
    },
    describeWhatHappendTitle: {
        id: 'portal.fnol.wc.views.what.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    injuryCauseSourceLabel: {
        id: 'portal.fnol.wc.views.what.Injury Cause/Source',
        defaultMessage: 'Injury Cause/Source'
    },
    selectInjuryCauseSourceLabel: {
        id: 'portal.fnol.wc.views.what.Select Injury Cause/Source',
        defaultMessage: '-- Select Injury Cause/Source --'
    },
    detailCauseOfIncidentLabel: {
        id: 'portal.fnol.wc.views.what.Indicate who or what caused the incident, and provide other details that would be helpful.',
        defaultMessage: 'Indicate who or what caused the incident, and provide other details that would be helpful.'
    },
    dateEmployerNotifiedLabel: {
        id: 'portal.fnol.wc.views.what.Date Employer Notified',
        defaultMessage: 'Date Employer Notified'
    },
    submitAsReportLabel: {
        id: 'portal.fnol.wc.views.what.Submit as report only?',
        defaultMessage: 'Submit as report only?'
    },
    injuredEmployeeLabel: {
        id: 'portal.fnol.wc.views.what.Injured employee',
        defaultMessage: 'Injured employee'
    },
    firstNameLabel: {
        id: 'portal.fnol.wc.views.what.First Name',
        defaultMessage: 'First Name'
    },
    lastNameLabel: {
        id: 'portal.fnol.wc.views.what.Last Name',
        defaultMessage: 'Last Name'
    },
    phoneNumberLabel: {
        id: 'portal.fnol.wc.views.what.Phone Number',
        defaultMessage: 'Phone Number'
    },
    socialSecurityNumberLabel: {
        id: 'portal.fnol.wc.views.what.Social Security Number',
        defaultMessage: 'Social Security Number'
    },
    dateOfBirthLabel: {
        id: 'portal.fnol.wc.views.what.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    genderLabel: {
        id: 'portal.fnol.wc.views.what.Gender',
        defaultMessage: 'Gender'
    },
    selectGenderLabel: {
        id: 'portal.fnol.wc.views.what.Select Gender',
        defaultMessage: '-- Select Gender --'
    },
    Delete: {
        id: 'portal.fnol.wc.views.Delete',
        defaultMessage: 'Delete'
    }
});